import { BOOKING, GET_BOOKING } from '../types'

import { getFreightDetail } from '@/api/model/freight'
import $util from '@/services/ht.util'

export default {
  state: {
    // 供应商公司信息
    supplier: {},
    // 供应商联系人信息
    contact: {},
    // 运价信息
    freight: {},
    // 海运明细
    price: {},
    // 附加费
    surcharge: [],
    // 船期
    schedule: {},
    // 包装
    conts: {
      gp20: 0,
      gp40: 0,
      gp40hq: 0,
      gp45hq: 0,
      gp20rf: 0,
      gp40rf: 0,
      gpRt: 0,
      gpCbm: 0,
    },
  },
  getters: {
    supplier: (state) => {
      return state.supplier
    },
    contact: (state) => {
      return state.contact
    },
    freight: (state) => {
      return state.freight
    },
    price: (state) => {
      return state.price
    },
    surcharge: (state) => {
      return state.surcharge
    },
    schedule: (state) => {
      return state.schedule
    },
    conts: (state) => {
      return state.conts
    },
  },
  mutations: {
    [BOOKING](state, data) {
      let freight = data.EFclFreight || data.ELclFreight || data.EAirFreight
      let price = data.EFclFreightPrice || data.ELclFreightPrice || data.EAirFreightPrice
      let surcharge = data.EFclSurcharge || data.ELclSurcharge || data.EAirSurcharge
      let priceList = $util.ToArry(price)
      Object.assign(state.supplier, data.PCompany)
      Object.assign(state.contact, data.PUser)
      Object.assign(state.schedule, data.ESchedule)
      Object.assign(state.freight, freight)
      Object.assign(state.price, priceList[1] || priceList[0])
      Object.assign(state.surcharge, $util.ToArry(surcharge))
      Object.assign(state.conts, data.cont)
    },
  },
  actions: {
    [BOOKING]({ commit, state }, bookData) {
      commit(BOOKING, bookData)
    },
    [GET_BOOKING]({ commit }, id, type) {
      getFreightDetail({
        id: id,
        type: type,
      }).then((res) => {
        commit(BOOKING, res)
      })
    },
  },
}
